export default __webpack_public_path__ + "datedropper.svg?9be5ab0eb92840a2b10d121427eee03a";